var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { class: [_vm.isFolder ? "folder" : "file"] }, [
    _vm.model.type !== "delimiter"
      ? _c(
          "a",
          {
            staticClass: "menu-label",
            class: { open: _vm.open },
            attrs: { href: _vm.model.href }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.model.title) + "\n      "),
            _vm.isFolder
              ? _c("span", {
                  staticClass:
                    "cd-accordion-menu--arrow cd-accordion-menu--arrow_default",
                  class: { "cd-accordion-menu--arrow_open": _vm.open },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.toggle($event)
                    }
                  }
                })
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.model.type === "delimiter"
      ? _c("div", { staticClass: "delimiter" })
      : _vm._e(),
    _vm._v(" "),
    _vm.isFolder
      ? _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            class: { open: _vm.open }
          },
          _vm._l(_vm.model.child, function(model, index) {
            return _c("MenuItem", { key: index, attrs: { model: model } })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }